import { AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { SepaFacade } from '@zero/self-service/domain';
import { MicarContractsNudgingComponent } from '@zero/shared/feature-contract-confirmation/web';
import { InstrumentDetailsLinkComponent, TradingSessionComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, IconButtonComponent, IconComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { InstrumentType, SavingsPlan } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { HasCryptoPipe } from '../../../../pipes/has-crypto/has-crypto.pipe';

@Component({
  selector: 'saving-plans-saving-plan-existing-plans',
  templateUrl: './saving-plan-existing-plans.component.html',
  imports: [
    RouterLink,
    InstrumentDetailsLinkComponent,
    TradingSessionComponent,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
    AsyncPipe,
    ButtonComponent,
    IconButtonComponent,
    IconComponent,
    ModalComponent,
    HasCryptoPipe,
    MicarContractsNudgingComponent,
  ],
})
export class SavingPlanExistingPlansComponent {
  @Input() public savingPlans: SavingsPlan[];
  @Input() public savingsPlansDirectDebitActive: boolean;

  public isAuthorized: boolean;
  public readonly cryptoType = InstrumentType.Crypto;
  public readonly sepaFacade = inject(SepaFacade);
  public readonly add_savings_plan = commonRoutes.postlogin.add_savings_plan;
  public readonly edit_savings_plan = commonRoutes.postlogin.edit_savings_plan;
  public readonly verwaltungKtoDepot = `${commonRoutes.postlogin.verwaltung}?section=konto-depot`;
  readonly #savingPlansFacade = inject(SavingsPlanFacade);
  readonly #ngbModal = inject(NgbModal);

  @ViewChild('dynamizationInfo', { static: true }) private readonly _content: ElementRef;

  #savingsPlansToDelete: SavingsPlan[] = [];

  public askForDeletion = (plan: SavingsPlan) => this.#savingsPlansToDelete.push(plan);

  public delete = async (plan: SavingsPlan) => this.#savingPlansFacade.cancelSavingsPlan(plan.id);

  public isAskingForDeletion = (plan: SavingsPlan) => this.#savingsPlansToDelete.includes(plan);

  public abortDeletion = (plan: SavingsPlan) =>
    (this.#savingsPlansToDelete = this.#savingsPlansToDelete.filter((planToDelete) => planToDelete !== plan));

  public isReady = (status: string) => status !== 'atwork';

  public activateDirectDebit = () => this.sepaFacade.toggleSepa(true);

  public openDynamizationInfo = () => this.#ngbModal.open(this._content, { size: 'md' });
}
